import React from "react";
import { useSelector } from "react-redux";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { EmptyTabContainer } from "src/app/Task/tabs/ProfileDataTab/components/EmptyTabs/EmptyTabContainer/EmptyTabContainer";
import { EmptyTabContent } from "src/app/Task/tabs/ProfileDataTab/components/EmptyTabs/EmptyTabContent/EmptyTabContent";
import pieChartImage from "src/images/pie-chart.svg";
import { RootState } from "src/redux/reducers";
import { ProjectPermissionsEnum } from "src/utils/PermissionsEnums";

interface Props {
  openAddCreatorsModal: () => void;
}

export const EmptyAudienceOverlapTab = (props: Props) => {
  const { openAddCreatorsModal } = props;

  const { projectBasicData } = useSelector(
    (state: RootState) => state.projectReducer,
  );

  const canCalculateAO = projectBasicData?.permissions?.project.includes(
    ProjectPermissionsEnum.CALCULATE_PROJECT_AUDIENCE_OVERLAP,
  );

  return (
    <EmptyTabContainer className="empty-social-profiles-tab">
      <EmptyTabContent
        header={
          <IDHFormattedMessage
            id="ws_no_audience_data_yet"
            defaultMessage="No audience data yet"
          />
        }
        text={
          <IDHFormattedMessage
            id="ws_run_an_analysis_to_see_how_much_your_creators_audiences_overlap"
            defaultMessage="Run an analysis to see how much your creators’ audiences overlap."
          />
        }
        imgUrl={pieChartImage}
        onButtonClick={canCalculateAO && openAddCreatorsModal}
        buttonText={
          <IDHFormattedMessage
            id="ws_select_creators"
            defaultMessage="Select creators"
          />
        }
        buttonDataQa="select-creators-button"
      />
    </EmptyTabContainer>
  );
};
